import React, { Component } from "react";
import { connect } from "react-redux";
import { actions as userActions } from "../../redux/modules/user";
import { actions as activeActions } from "../../redux/modules/active";
import { post } from "../../utils/request";
import { jumpUrl } from "../../utils/tool";
import "./style.css";
import "../../index.css";
class Active extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error_visible: false,
      shake_visible: false,
      error_info: "",
      code: "",
    };
  }
  render() {
    return (
      <div
        style={
          this.props.activeUI.showActive === true
            ? { display: "block" }
            : { display: "none" }
        }
        className="active_box"
      >
        <div className="active_inline_box">
          <div onClick={() => this.handleClose()} className="active_close">
            <img alt="" src={require("../../images/user/close.png")}></img>
          </div>
          <img
            className="active_img"
            alt=""
            src={require("../../images/my/active_code.png")}
          ></img>
          <div className="active_phone">
            <input
              onChange={this.handleCodeChang}
              placeholder="请输入激活码"
              className="fl"
            ></input>
          </div>
          <div className="active_module">
            <div
              style={
                this.state.error_visible === true
                  ? { display: "block" }
                  : { display: "none" }
              }
              className={
                this.state.shake_visible === true
                  ? "active_error shake"
                  : "active_error"
              }
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: "* " + this.state.error_info,
                }}
              ></div>
            </div>
          </div>

          <div onClick={() => this.requestActive()} className="active_btn">
            激 活
          </div>
        </div>
      </div>
    );
  }
  /**
   * 关闭登陆框
   */
  handleClose = () => {
    this.setState({
      error_info: "",
      error_visible: false,
    });
    const { dispatch } = this.props;
    dispatch(activeActions.setShowActive(false));
  };
  /**
   * 激活码
   */
  handleCodeChang = (e) => {
    this.setState({
      code: e.target.value,
    });
  };
  /**
   * 激活请求
   */
  requestActive = () => {
    if (this.state.code === "") {
      this.setState({
        error_visible: true,
        error_info: "请输入激活码",
        shake_visible: true,
      });
      this.handleRemoveShake();
      return;
    }
    post("/public/v1/user/active/" + this.state.code).then((res) => {
      const { dispatch } = this.props;
      if (res.status === "success") {
        this.setState({
          error_visible: false,
          error_info: "",
          shake_visible: false,
        });
        dispatch(activeActions.setShowActiveSuccess(true));
        dispatch(activeActions.setShowActive(false));
        if (res.data === "完全激活") {
          dispatch(userActions.setUserDayUpLink("/day"));
          setTimeout(() => {
            jumpUrl("dayup");
          }, 3000);
        } else {
          setTimeout(() => {
            jumpUrl("pay");
          }, 3000);
        }
      } else {
        this.setState({
          error_visible: true,
          error_info: res.data.err_msg,
          shake_visible: true,
        });
        this.handleRemoveShake();
      }
    });
  };
  /**
   * 移除提示语抖动效果
   */
  handleRemoveShake = () => {
    setTimeout(() => {
      this.setState({
        shake_visible: false,
      });
    }, 800);
  };
}
const mapStateToProps = (state) => {
  return {
    activeUI: state.active.uiStateData,
  };
};

export default connect(mapStateToProps)(Active);



// WEBPACK FOOTER //
// ./src/components/Active/index.js